define('app/filters/controls/RollingDateFilterControl',['require','./SelectFilterControl','glu/util','hbs!./RollingDateFilterControl.hbs'],function(require) {
	'use strict';

	var InFilterControl = require('./SelectFilterControl'),
		_ = require('glu/util');

	var UNIT_TYPE = {
		DAY: 'DAY',
		WEEK: 'WEEK',
		MONTH: 'MONTH',
		YEAR: 'YEAR'
	};

	// the default selection is 'last week'
	var lastSelected = {
		backUnitType: UNIT_TYPE.WEEK,
		backUnitLength: 1,
		durationUnitType: UNIT_TYPE.WEEK,
		durationUnitLength: 1
	};

	return InFilterControl.extend({
		template: require('hbs!./RollingDateFilterControl.hbs'),

		initialize: function() {
			// TODO need a better way to override lastSelected
			if (this.model.get('values').length === 1) {
				lastSelected = this.model.get('values')[0];
			}
		},

		value: function() {
			var selectedValue = _.find(this.FILTER_OPTIONS, function(option) {
				return _.isEqual(option.value, lastSelected);
			});

			if (selectedValue) {
				return selectedValue.label;
			}

			return null;
		},

		selectableOptions: function() {
			return _.map(this.FILTER_OPTIONS, function(option) {
				return {
					value: option.name,
					label: option.label,
					isSelected: _.isEqual(option.value, lastSelected)
				};
			});

		},

		updateModel: function() {
			var selectedValue = this.$el.find('[name=value]').val();
			var selectedOption = _.find(this.FILTER_OPTIONS, function(option) {
				return option.name === selectedValue;
			});
			if (selectedOption) {
				this.model.setValue(0, selectedOption.value);
				lastSelected = selectedOption.value;
			}
		},
		onRender: function() {
			this.$('.select-box').comboBox();
			this.updateModel();
		},

		FILTER_OPTIONS: [{
			name: 'YESTERDAY',
			label: 'Yesterday',
			value: {
				backUnitType: UNIT_TYPE.DAY,
				backUnitLength: 1,
				durationUnitType: UNIT_TYPE.DAY,
				durationUnitLength: 1
			}
		}, {
			name: 'LAST7DAYS',
			label: 'last 7 days',
			value: {
				backUnitType: UNIT_TYPE.DAY,
				backUnitLength: 7,
				durationUnitType: UNIT_TYPE.DAY,
				durationUnitLength: 7
			}
		}, {
			name: 'LAST30DAYS',
			label: 'last 30 days',
			value: {
				backUnitType: UNIT_TYPE.DAY,
				backUnitLength: 30,
				durationUnitType: UNIT_TYPE.DAY,
				durationUnitLength: 30
			}
		}, {
			name: 'LASTWEEK',
			label: 'last week',
			value: {
				backUnitType: UNIT_TYPE.WEEK,
				backUnitLength: 1,
				durationUnitType: UNIT_TYPE.WEEK,
				durationUnitLength: 1
			}
		}, {
			name: 'THISWEEK',
			label: 'this week',
			value: {
				backUnitType: UNIT_TYPE.WEEK,
				backUnitLength: 0,
				durationUnitType: UNIT_TYPE.WEEK,
				durationUnitLength: 1
			}
		}, {
			name: 'LASTMONTH',
			label: 'last month',
			value: {
				backUnitType: UNIT_TYPE.MONTH,
				backUnitLength: 1,
				durationUnitType: UNIT_TYPE.MONTH,
				durationUnitLength: 1
			}
		}, {
			name: 'THISMONTH',
			label: 'this month',
			value: {
				backUnitType: UNIT_TYPE.MONTH,
				backUnitLength: 0,
				durationUnitType: UNIT_TYPE.MONTH,
				durationUnitLength: 1
			}
		}, {
			name: 'LAST12MONTHS',
			label: 'last 12 months',
			value: {
				backUnitType: UNIT_TYPE.MONTH,
				backUnitLength: 12,
				durationUnitType: UNIT_TYPE.MONTH,
				durationUnitLength: 12
			}
		}, {
			name: 'LASTYEAR',
			label: 'last year',
			value: {
				backUnitType: UNIT_TYPE.YEAR,
				backUnitLength: 1,
				durationUnitType: UNIT_TYPE.YEAR,
				durationUnitLength: 1
			}
		}, {
			name: 'THISYEAR',
			label: 'this year',
			value: {
				backUnitType: UNIT_TYPE.YEAR,
				backUnitLength: 0,
				durationUnitType: UNIT_TYPE.YEAR,
				durationUnitLength: 1
			}
		}]
	});

});

